import { useState, useCallback, useRef } from "react";

type ToastState = { id: number; text: string; type: "success" | "error" } | null;

export function useToast() {
  const [toast, setToast] = useState<ToastState>(null);
  const timerRef = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);

  const show = useCallback((text: string, type: "success" | "error" = "success") => {
    clearTimeout(timerRef.current);
    setToast({ id: Date.now(), text, type });
    timerRef.current = setTimeout(() => setToast(null), 3000);
  }, []);

  const ToastUI = toast ? (
    <div
      key={toast.id}
      className={`fixed bottom-5 right-5 z-[200] flex items-center gap-2.5 rounded-xl px-4 py-3 text-sm font-medium shadow-lg transition-all ${
        toast.type === "success"
          ? "bg-green-500 text-white"
          : "bg-red-500 text-white"
      }`}
    >
      {toast.type === "success" ? (
        <svg className="h-4 w-4 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
        </svg>
      ) : (
        <svg className="h-4 w-4 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      )}
      <span>{toast.text}</span>
    </div>
  ) : null;

  return { show, ToastUI };
}
